import HomePage from '../components/home';
import Ficha from '../components/ficha';
import Lista from '../components/listado';
import Episodio from '../components/Episodio';
import Favoritos from '../components/favoritos';

var routes = [
    {
        path: '/',
        component: HomePage,
    },
    {
        path: '/favoritos',
        component: Favoritos,
    },
    {
        path: '/anime/:id',
        component: Ficha,
    },
    {
        path: '/anime/:idAnime/episodio/:idEpisodio',
        component: Episodio,
    },
    {
        path: '/animes/:tipo/:busqueda',
        component: Lista,
    },
    /*
    {
        path: '(.*)',
        component: NotFoundPage,
    },
     */
];

export default routes;
